<app-spinner-service></app-spinner-service>

<app-toolbar-search (onSearch)="applyFilterGlobal($event)" placeholder="Pesquise por período, tipo, valor, descrição...">
  <div leftContent>
    <button pButton label="Novo Lançamento de Caixa" icon="pi pi-plus" (click)="navigateToAddLancamento()"></button>
  </div>
</app-toolbar-search>

<p-confirmDialog></p-confirmDialog>

<p-table #dt [value]="lancamentosDeCaixa" [paginator]="true" [rows]="10" selectionMode="single"
  [(selection)]="selectedLancamentoCaixa" [globalFilterFields]="['Periodo', 'Tipo', 'Valor', 'Descricao']"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" class="custom-table"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50]">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="Periodo" style="width: 15%">Período <p-sortIcon field="Periodo"></p-sortIcon></th>
      <th pSortableColumn="Tipo" style="width: 15%">Tipo <p-sortIcon field="Tipo"></p-sortIcon></th>
      <th pSortableColumn="Valor" style="width: 20%">Valor <p-sortIcon field="Valor"></p-sortIcon></th>
      <th pSortableColumn="Descricao" style="width: 35%">Descrição <p-sortIcon field="Descricao"></p-sortIcon></th>
      <th style="width: 15%">Ações</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-lancamentoCaixa>
    <tr>
      <td>
        <div class="period-content">
          <i class="pi pi-calendar period-icon"></i>
          <span class="period-text" [pTooltip]="transformaData(lancamentoCaixa.Periodo)" tooltipPosition="top">{{ transformaData(lancamentoCaixa.Periodo) }}</span>
        </div>
      </td>
      <td>
        <div class="type-content">
          <i class="pi pi-tag type-icon"></i>
          <span class="type-text" [pTooltip]="retornaLancamentoCaixaTipoEnum(lancamentoCaixa.Tipo)" tooltipPosition="top">{{ retornaLancamentoCaixaTipoEnum(lancamentoCaixa.Tipo) }}</span>
        </div>
      </td>
      <td>
        <div class="value-content">
          <i class="pi pi-dollar value-icon"></i>
          <span class="value-text" [pTooltip]="lancamentoCaixa.Valor | currency:'BRL'" tooltipPosition="top">{{ lancamentoCaixa.Valor | currency:'BRL' }}</span>
        </div>
      </td>
      <td>
        <div class="description-content">
          <i class="pi pi-align-left description-icon"></i>
          <span class="description-text" [pTooltip]="lancamentoCaixa.Descricao" tooltipPosition="top">{{ lancamentoCaixa.Descricao }}</span>
        </div>
      </td>
      <td class="text-center">
        <div class="actions-content">
          <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info action-button"
            (click)="detalhesLancamentoCaixa(lancamentoCaixa)" pTooltip="Ver Detalhes" tooltipPosition="top"></button>
          <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger action-button"
            (click)="excluirLancamentoCaixa(lancamentoCaixa.Id)" pTooltip="Excluir Lançamento" tooltipPosition="top"></button>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-wallet" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum lançamento encontrado</h3>
          <p>Não há lançamentos de caixa registrados no sistema.</p>
          <button pButton label="Novo Lançamento" icon="pi pi-plus" (click)="navigateToAddLancamento()" class="p-button-primary"></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="detailsDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  header="Detalhes do Lançamento de Caixa"
  styleClass="app-detail-dialog"
  [style]="{ width: '90vw', maxWidth: '900px' }"
  [breakpoints]="{ '1199px': '95vw', '575px': '98vw' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }">
  <div class="dialog-content-wrapper" *ngIf="selectedLancamentoCaixa">
    <div class="detail-card">
      <div class="detail-header">
        <div class="header-icon"><i class="pi pi-credit-card"></i></div>
        <div class="header-info">
          <h2 class="detail-title">{{ selectedLancamentoCaixa.Descricao }}</h2>
          <p class="detail-subtitle">Lançamento de Caixa · {{ transformaData(selectedLancamentoCaixa.Periodo) }}</p>
        </div>
        <div class="header-badges">
          <span *ngIf="selectedLancamentoCaixa.Tipo === 0" class="chip chip-recebimento"><i class="pi pi-arrow-down"></i> Recebimento</span>
          <span *ngIf="selectedLancamentoCaixa.Tipo === 1" class="chip chip-pagamento"><i class="pi pi-arrow-up"></i> Pagamento</span>
        </div>
      </div>

      <div class="resumo-valores">
        <div class="valor-card" [ngClass]="selectedLancamentoCaixa.Tipo === 0 ? 'valor-card--positivo' : 'valor-card--negativo'">
          <div class="valor-card__icon"><i class="pi pi-dollar"></i></div>
          <div class="valor-card__content">
            <span class="valor-card__label">Valor</span>
            <span class="valor-card__value">{{ selectedLancamentoCaixa.Valor | currency:'BRL' }}</span>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title"><i class="pi pi-info-circle"></i><span>Informações do Lançamento</span></div>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-calendar"></i><span>Período</span></div>
            <div class="detail-value">{{ transformaData(selectedLancamentoCaixa.Periodo) }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label"><i class="pi pi-tag"></i><span>Tipo</span></div>
            <div class="detail-value">
              <span *ngIf="selectedLancamentoCaixa.Tipo === 0" class="chip chip-recebimento"><i class="pi pi-arrow-down"></i> Recebimento</span>
              <span *ngIf="selectedLancamentoCaixa.Tipo === 1" class="chip chip-pagamento"><i class="pi pi-arrow-up"></i> Pagamento</span>
            </div>
          </div>
          <div class="detail-item full-width">
            <div class="detail-label"><i class="pi pi-file-edit"></i><span>Descrição</span></div>
            <div class="detail-value">{{ selectedLancamentoCaixa.Descricao }}</div>
          </div>
          <div class="detail-item full-width" *ngIf="selectedLancamentoCaixa.ContaContabilDescricao">
            <div class="detail-label"><i class="pi pi-book"></i><span>Conta Contábil</span></div>
            <div class="detail-value">{{ selectedLancamentoCaixa.ContaContabilDescricao }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton label="Fechar" icon="pi pi-times" class="p-button-secondary" (click)="detailsDialogVisible = false"></button>
  </ng-template>
</p-dialog>
